import { render, staticRenderFns } from "./appSmsAddEdit.vue?vue&type=template&id=22666be6"
import script from "./appSmsAddEdit.vue?vue&type=script&lang=js"
export * from "./appSmsAddEdit.vue?vue&type=script&lang=js"
import style0 from "./appSmsAddEdit.vue?vue&type=style&index=0&id=22666be6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports